module.exports = "<h3 class=\"h3-responsive\">Payment: {{order?.id}} <a class=\"btn btn-primary\" [routerLink]=\"['/admin', 'my-account']\">Back to Payment History</a></h3>\n<view-order [order]=\"order\"></view-order>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/view-order-page/view-order-page.component.html
// module id = ./src/app/admin/view-order-page/view-order-page.component.html
// module chunks = main